import React, { useState, useCallback, useMemo } from 'react';

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

import { DateRange } from 'react-date-range';
import { Box, Typography, Button, Menu } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { format } from 'date-fns';

import useStyles from './DatePicker.styles';
import { themeColors } from '../../styles/themeColors';

export interface IDatePickerProps {
  range: { startDate: Date; endDate: Date };
  onChange: (selectedRange: { startDate: Date; endDate: Date }) => void;
}

const DatePicker: React.FC<IDatePickerProps> = ({ range, onChange }) => {
  const styles = useStyles();

  const [dateRange, setDateRange] = useState(range);

  const [clicks, setClicks] = useState(0);

  const selectionRange = useMemo(
    () => ({
      ...dateRange,
      key: 'selectedRange',
    }),
    [dateRange],
  );

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = useCallback((event: any) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
    onChange(dateRange);
  }, [dateRange, onChange]);

  const handleRangeChange = useCallback(
    ({ selectedRange }: { selectedRange: IDatePickerProps['range'] }) => {
      setDateRange(selectedRange);
      if (clicks < 1) {
        setClicks((cv) => cv + 1);
      } else {
        setClicks(0);
        setAnchorEl(null);
        onChange(selectedRange);
      }
    },
    [clicks, onChange],
  );

  return (
    <Box>
      <Button
        endIcon={<ArrowDropDownIcon color="primary" />}
        onClick={handleClick}
        className={styles.buttonContainer}
        variant="contained"
      >
        <Typography color="textPrimary">
          {format(dateRange.startDate, 'yyyy-MM-dd')} - {format(dateRange.endDate, 'yyyy-MM-dd')}
        </Typography>
      </Button>
      <Menu
        id="simple-menu"
        keepMounted
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <DateRange
          weekStartsOn={1}
          ranges={[selectionRange]}
          // @ts-ignore error in library types
          onChange={handleRangeChange}
          rangeColors={[themeColors.selected, themeColors.primary]}
        />
      </Menu>
    </Box>
  );
};

export default DatePicker;
